import Logo from "../../assets/images/logo_dark.svg";
import LogoCollapsed from "../../assets/images/logo_collapsed.svg";
const CollapseIcon = ({ collapsed = false }) => {
  return (
    <img
      src={collapsed ? LogoCollapsed : Logo}
      alt="Logo"
      style={{
        margin: "0 auto",
        width: `${collapsed ? "40px" : "205px"}`,
        height: `${collapsed ? "48px" : "60px"}`,
        marginTop: "20px",
        marginBottom: "20px",
        display: `${collapsed ? "block" : ""}`,
      }}
    />
  );
};
export default CollapseIcon;
// margin: 18px;
//     width: 205px;
//     height: 54px;